module.exports = fox._r("images/tips-img.jpg", __webpack_public_path__ + "images/tips-img.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/tips-img.jpg
// module id = 1131
// module chunks = 4